import { TCustomerUserDetailDto } from "@/api/services/main/customer-user/dtos/customer-user.dto";
import { IconOutlineInfo } from "@/assets/icons/IconOutlineInfo";
import { InnerBox } from "@/components/elements/InnerBox";
import { Tooltip } from "@/components/elements/Tooltip";
import { ReadonlyField } from "@/features/customer-user/components/detail/ReadonlyField";
import { UserRoleHelperContent } from "@/features/customer-user/components/UserRoleHelperContent";
import { text } from "@/theme/colors";
import { USER_ROLE_LABEL, TUserRole } from "@/types/enum";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export const BasicInfoSection: FC<{ user: TCustomerUserDetailDto }> = ({ user }) => {
  const roleLabel = USER_ROLE_LABEL[user.role as TUserRole] ?? user.role;

  const emailValue = user.newEmail ? (
    <Stack gap="4px">
      <Typography variant="body14Semi" color={text.primary}>
        {user.email}
      </Typography>
      <Typography variant="body14Semi" color={text.primary}>
        {user.newEmail} (確認中)
      </Typography>
    </Stack>
  ) : (
    user.email
  );

  return (
    <InnerBox title="基本情報" padding="24px">
      <Stack gap="24px">
        <Stack direction="row" gap="48px" flexWrap="wrap">
          <ReadonlyField label="ユーザー名" required value={user.fullName} underline />
          <ReadonlyField
            label={
              <Stack direction="row" alignItems="center">
                <span>権限</span>
                <Tooltip title="留意事項" content={<UserRoleHelperContent />}>
                  <IconOutlineInfo />
                </Tooltip>
              </Stack>
            }
            underline
            required
            value={roleLabel}
          />
        </Stack>
        <Stack direction="row" gap="48px" flexWrap="wrap">
          <ReadonlyField label="メールアドレス" required value={emailValue} underline />
          <Stack flex={1} minWidth={0} />
        </Stack>
      </Stack>
    </InnerBox>
  );
};
